import { render } from "./HouseTypeListComponent.vue?vue&type=template&id=4a01181e&scoped=true"
import script from "./HouseTypeListComponent.vue?vue&type=script&lang=js"
export * from "./HouseTypeListComponent.vue?vue&type=script&lang=js"

import "./HouseTypeListComponent.vue?vue&type=style&index=0&id=4a01181e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a01181e"]])

export default __exports__